import React, { useEffect, useState } from 'react';
import { Button, Progress } from 'reactstrap';
import Form1 from './Form1';
import Form2 from './Form2';
import { useDispatch, useSelector } from 'react-redux';
import { CREATE_SPIN_GAME, GET_GAMIFICATION_LIST, UPDATE_GAME_STATUS } from '../../../../../../../../store/actions';
import { get } from 'lodash';
import cogoToast from 'cogo-toast';
import { FaArrowLeft } from 'react-icons/fa';

const totalSteps = 2;

const SpinTheWheel = ({ currentGameDetails }) => {
  const dispatch = useDispatch();

  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    game_id: '',
    game_name: '',
    type: '',
    status: '',
    min_coins_required: '',
    start_date: '',
    end_date: '',
    play_duration: '',
    play_duration_unit: '',
    multipleSpinAllowed: false,
    tat: 1,
    tat_unit: 'seconds',
    total_attempts: '1',
    is_featured: false,
    banner: '',
  });

  const [errors, setErrors] = useState({});
  const [prizePoolRows, setPrizePoolRows] = useState([
    { rewardType: '', points: '', probability: '', maxUnit: '', benefits: '', serviceConfigId: '' },
  ]);
  const [rowErrors, setRowErrors] = useState([]);

  const { getGamificationList } = useSelector((state: any) => ({
    getGamificationList: state?.GetGamificationList?.data,
  }));

  useEffect(() => {
    if (currentGameDetails !== null) {
      dispatch({
        type: GET_GAMIFICATION_LIST,
        payload: {
          game_id: currentGameDetails?.game_id,
        },
      });
    }
  }, [currentGameDetails]);

  useEffect(() => {
    if (getGamificationList !== null) {
      const initialGameDetails = {
        game_id: getGamificationList?.game_id,
        game_name: getGamificationList?.game_name || '',
        type: getGamificationList?.type || '',
        status: getGamificationList?.status || '',
        min_coins_required: getGamificationList?.min_coins_required ?? '',
        start_date: getGamificationList?.start_date || '',
        end_date: getGamificationList?.end_date || '',
        play_duration: getGamificationList?.play_duration || '',
        play_duration_unit: getGamificationList?.play_duration_unit || '',
        multipleSpinAllowed: getGamificationList?.total_attempts > 1 ? true : false,
        tat: getGamificationList?.tat,
        tat_unit: getGamificationList?.tat_unit,
        total_attempts: getGamificationList?.total_attempts,
        is_featured: getGamificationList?.is_featured,
        banner: getGamificationList?.banner,
      };

      const initialPrizePoolRows = getGamificationList?.rewards?.map(reward => {
        return {
          benefits: reward?.reward_id,
          maxUnit: reward?.max_unit_allowed,
          points: reward?.points,
          probability: reward?.win_probability,
          rewardType: reward?.points === 0 ? 'benefits' : 'points',
          serviceConfigId: reward?.service_config_id || '',
        };
      });
      console.log('gamingcheck', initialGameDetails);
      setFormData(initialGameDetails);
      setPrizePoolRows(initialPrizePoolRows ?? []);
    }
  }, [getGamificationList]);
  console.log();

  const validateForm1 = () => {
    const newErrors: any = {};

    if (!formData.game_name?.trim()) newErrors.game_name = 'Game name is required';
    else if (formData.game_name.trim().length > 50) newErrors.game_name = 'Game name must be under 50 characters';

    if (!formData.status) newErrors.status = 'Status is required';
    if (!formData.banner) newErrors.banner = 'Game Banner is required';
    // if (formData.banner) newErrors.banner = ''

    if (
      formData.min_coins_required === '' ||
      formData.min_coins_required === null ||
      formData.min_coins_required === undefined ||
      Number(formData.min_coins_required) < 0
    )
      newErrors.min_coins_required = 'Min points is required';
    else if (Number(formData.min_coins_required) < 0) newErrors.min_coins_required = 'Min points must be greater than or equal to 0';

    if (!formData.start_date) newErrors.start_date = 'Start Date is required';
    if (!formData.end_date) newErrors.end_date = 'End Date is required';

    // Date comparison
    if (formData.start_date && formData.end_date) {
      const start = new Date(formData.start_date);
      const end = new Date(formData.end_date);

      if (end < start) {
        newErrors.end_date = 'End Date must be after Start Date';
      }
    }

    if (!formData.play_duration) newErrors.play_duration = 'Overall Spin Time is required';
    else if (Number(formData.play_duration) <= 0) newErrors.play_duration = 'Spin time must be greater than 0';
    // else if (Number(formData?.play_duration) > 60) newErrors.play_duration = 'Spin time should be in betweeen 1 minute'

    if (!formData.play_duration_unit) newErrors.play_duration_unit = 'Overall Spin Unit is required';
    if (formData?.play_duration_unit == 'minutes') {
      if (Number(formData?.play_duration) > 59 || Number(formData?.play_duration) < 1) {
        newErrors.play_duration = 'Spin time should be in betweeen 1 to 59 minutes';
      }
    }
    if (formData?.play_duration_unit == 'seconds') {
      if (Number(formData?.play_duration) > 60 || Number(formData?.play_duration) < 1) {
        newErrors.play_duration = 'Spin time should be in betweeen 1 to 60 seconds';
      }
    }

    if (formData.multipleSpinAllowed) {
      if (!formData.tat) newErrors.tat = 'Time between spins is required';
      else if (Number(formData.tat) <= 0) newErrors.tat = 'Time between spins must be greater than 0';

      if (!formData.tat_unit) newErrors.tat_unit = 'Spin gap unit is required';

      if (!formData.total_attempts) newErrors.total_attempts = 'User attempts is required';
      else if (Number(formData.total_attempts) <= 1) newErrors.total_attempts = 'Attempts must be greater than 1 if multiple spins are allowed.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateForm2 = () => {
    const errors = [];
    let sum = 0;

    if (prizePoolRows.length <= 1) {
      cogoToast.error('At least two spins is required for the game');
      return false;
    }
    prizePoolRows.forEach((row, index) => {
      const rowError: any = {};

      // Required: rewardType
      if (!row.rewardType) {
        rowError.rewardType = 'Reward type is required';
      }

      // Conditionally required field based on reward type
      if (row.rewardType === 'points') {
        if (!row?.points || Number(row?.points) <= 0) {
          rowError.points = 'Points must be greater than or equal to 1';
        }
      } else if (row.rewardType === 'benefits') {
        if (!row.benefits) {
          rowError.benefits = 'Please select a benefits';
        }
      }

      // Validate win probability
      if (!row.probability) {
        rowError.probability = 'Win probability is required';
      } else {
        const numericProb = parseFloat(String(row.probability).replace('%', ''));
        sum += numericProb;
        if (isNaN(numericProb) || numericProb <= 0 || numericProb > 100) {
          rowError.probability = 'Enter a valid percentage (1-100%)';
        }
      }

      if (!row.maxUnit) {
        // Validate max unit
        rowError.maxUnit = 'Max unit must be a positive number';
      }

      errors.push(rowError);
    });

    if (sum !== 100) {
      cogoToast.error('Total win probability must equal 100%');
      return false;
    }

    setRowErrors(errors);
    return errors.every(err => Object.keys(err).length === 0);
  };

  const handleNext = () => {
    console.log('handleNext called, current step:', step === 2 && validateForm2());
    if (step === 1 && validateForm1()) {
      setStep(2);
    } else if (step === 2 && validateForm2()) {
      const payoad = {
        game_name: formData.game_name,
        status: formData.status,
        min_coins_required: formData.min_coins_required ? Number(formData.min_coins_required) : 0,
        start_date: formData.start_date,
        end_date: formData.end_date,
        play_duration: (formData.play_duration && Number(formData.play_duration)) ?? 0,
        play_duration_unit: formData?.play_duration_unit || '',
        multipleSpinAllowed: formData?.multipleSpinAllowed,
        tat: formData.tat ? Number(formData.tat) : 0,
        tat_unit: formData.tat_unit || '',
        total_attempts: formData.total_attempts ? Number(formData.total_attempts) : 0,
        rewards: prizePoolRows.map(row => ({
          type: row.rewardType,
          points: row.points ? Number(row.points) : 0,
          win_probability: row.probability ? Number(row.probability) : 0,
          max_unit_allowed: row.maxUnit ? Number(row.maxUnit) : 0,
          reward_id: row.benefits || '',
          ...(row.serviceConfigId && { service_config_id: row.serviceConfigId }),
        })),
        is_featured: formData?.is_featured,
        banner: formData?.banner,
      };

      if (currentGameDetails) {
        dispatch({
          type: UPDATE_GAME_STATUS,
          payload: {
            data: {
              ...payoad,
              game_id: formData?.game_id,
              type: formData?.type || '',
              ...(!payoad?.multipleSpinAllowed && {
                tat: 1,
                tat_unit: 'seconds',
                total_attempts: 1,
              }),
            },
            type: formData?.type || '',
          },
        });
      } else {
        dispatch({
          type: CREATE_SPIN_GAME,
          payload: {
            data: payoad,
            ...(!payoad?.multipleSpinAllowed && {
              tat: 1,
              tat_unit: 'seconds',
              total_attempts: 1,
            }),
          },
        });
      }
    }
  };

  const handleBack = () => setStep(prev => prev - 1);

  return (
    <div>
      <div className="d-flex align-items-center justify-content-end mb-4">
        <span className="me-2 fw-semibold">
          Step {step} / {totalSteps}
        </span>

        {/* Step 1 progress */}
        <div style={{ width: '40px' }} className="me-2">
          <Progress
            value={step >= 1 ? 100 : 0}
            color="success"
            style={{
              height: '8px',
              borderRadius: '10px',
              backgroundColor: '#e9ecef', // ensures the unfilled bar is visible
            }}
          />
        </div>

        {/* Step 2 progress */}
        <div style={{ width: '40px' }}>
          <Progress
            value={step >= 2 ? 100 : 0}
            color="success"
            style={{
              height: '8px',
              borderRadius: '10px',
              backgroundColor: '#e9ecef', // ensures the unfilled bar is visible
            }}
          />
        </div>
      </div>

      {step === 1 && <Form1 formData={formData} setFormData={setFormData} onNext={handleNext} errors={errors} setErrors={setErrors} />}
      {step === 2 && (
        <>
          <Button color="link" onClick={() => setStep(1)} className="mb-3 d-flex align-items-center gap-1 p-0">
            <FaArrowLeft />
            Back
          </Button>

          <Form2
            prizePoolRows={prizePoolRows}
            setPrizePoolRows={setPrizePoolRows}
            onNext={handleNext}
            rowErrors={rowErrors}
            setRowErrors={setRowErrors}
            isUpdate={currentGameDetails ? true : false}
          />
        </>
      )}
    </div>
  );
};

export default SpinTheWheel;
